import React from 'react';
import {NavLink} from "react-router-dom";

const AppHeader = () => {
  return (
    <header id="header">
      <div className="headerbar">
        <div className="headerbar-left">
          <ul className="header-nav header-nav-options">
            <li className="header-nav-brand">
              <div className="brand-holder">
                <NavLink to="/" exact>
                  <span className="text-lg text-bold text-primary">COVID-19 Sri Lanka</span>
                </NavLink>
              </div>
            </li>
            <li>
              <a className="btn btn-icon-toggle menubar-toggle" data-toggle="menubar">
                <i className="fa fa-bars"/>
              </a>
            </li>
          </ul>
        </div>
        <div className="headerbar-right">
          <ul className="header-nav header-nav-options">
            <li className="dropdown">
              <NavLink to='pharmacies' className="btn btn-default">
                <i className="fa fa-heartbeat"/> Pharmacies
              </NavLink>
            </li>
            <li className="dropdown">
              <NavLink to='groceries' className="btn btn-default">
                <i className="fa fa-shopping-cart"/> Groceries
              </NavLink>
            </li>
          </ul>
          {/*<ul className="header-nav header-nav-profile hidden-xs">
            <li className="dropdown">
              <a className="dropdown-toggle ink-reaction" data-toggle="dropdown">
                <img src="assets/img/avatar1.jpg?1403934956" alt=""/>
                <span className="profile-info">
                                      User Profile
                                      <small>coming soon</small>
                                  </span>
              </a>
              <ul className="dropdown-menu animation-dock">
                <li className="dropdown-header">Config</li>
                <li><a href="#">My profile (coming soon)</a></li>
                <li><a href="#">My alerts (coming soon)</a></li>
                <li className="divider"></li>
                <li><a href="#"><i className="fa fa-fw fa-lock"></i> Lock (coming soon)</a></li>
                <li><a href="#"><i className="fa fa-fw fa-power-off text-danger"></i> Logout (coming soon)</a></li>
              </ul>
            </li>
          </ul>*/}
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
